export enum CreditBackgroundCheckStatus {
  MANUALLY_CLOSED = 'Manually Closed',
  REPORT_DELIVERED = 'Report(s) Delivered',
  WAITING_AUTHORIZATION = 'Waiting Authorization',
  REPORT_REQUEST_ERROR = 'Report Request Error',
  BACKGROUND_COMPLETED = 'Background Completed',
}
